import react, { useEffect, useState, useRef, useContext } from 'react';

import { useOktaAuth } from '@okta/okta-react';
import { AxiosError, AxiosResponse } from 'axios';
import TooltipContent from '../../layout/TooltipContent';
import Description from '../../layout/Description';
import LoadingContext from './loading-context';
import ImageDataContext from '../../../providers/imageData-context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Collapse, Form, OverlayTrigger, Popover } from 'react-bootstrap';

export interface Props {}

const ImagesList: React.FC<Props> = (props) => {
    let pRefs = useRef<Array<HTMLTableRowElement | null>>([]);

    const { oktaAuth, authState } = useOktaAuth();
    const [checkedAll, setCheckedAll] = useState<boolean>(false);
    const [showContextPopup, setShowContextPopup] = useState<boolean>(true);

    const [error, setError] = useState<AxiosError>();
    const [isError, setIsError] = useState(false);
    const [response, setResponse] = useState<AxiosResponse>();

    const loadingCtx = useContext(LoadingContext);
    const imageDataCtx = useContext(ImageDataContext);

    const selectedItemsCount = imageDataCtx.imagesList.filter((i) => i.isChecked).length;

    const uid: string = authState.accessToken.claims?.uid;
    //const userName: string = authState.accessToken.claims?.sub;
    //const cid: string = authState.accessToken.claims?.cid;
    const accessToken: string = authState.accessToken.accessToken;

    useEffect(() => {
        if (!imageDataCtx.imagesList.length) {
            setCheckedAll(false);
            return;
        }

        setCheckedAll(imageDataCtx.imagesList.length === selectedItemsCount);
    }, [imageDataCtx.imagesList]);

    if (!authState) {
        return <div></div>;
    }

    const handleCheckedAllChange = (e: any) => {
        const newValue = e.currentTarget.checked;

        setCheckedAll(newValue);
        imageDataCtx.setImagesListCheckedAll(newValue);
    };

    const handleCheckedChange = (e: any, data: any) => {
        const newValue = e.currentTarget.checked;
        const documentName = data.documentName;

        imageDataCtx.setImagesListChecked(newValue, documentName);
    };

    const removeSelected = () => {
        setCheckedAll(false);
        if (selectedItemsCount > 0) {
            const itemsToRemove = imageDataCtx.imagesList.filter((i) => i.isChecked);
            // first chest if selected document is checked

            if (imageDataCtx.loadedImageDetails?.name) {
                // this means we have a loaded image
                const isLoadedImageSelected =
                    itemsToRemove.filter(
                        (i) => i.documentName == imageDataCtx.loadedImageDetails.name
                    ).length > 0;
                if (isLoadedImageSelected) {
                    imageDataCtx.clearLoadedImage();
                }
            }

            imageDataCtx.removeImagesFromImagesList(itemsToRemove);
        }
    };

    return (
        <>
            <div className='row'>
                <div className='col text-start checkAll'>
                    <Form.Check
                        style={{ width: '107px' }}
                        inline
                        className='fw-500 select-all-margin'
                        label='Select All'
                        name='optcheckbox'
                        type='checkbox'
                        onChange={(e) => {
                            handleCheckedAllChange(e);
                        }}
                        checked={checkedAll}
                        id='imageListCheckedAll'
                    />
                </div>
                <div className='col' style={{ maxWidth: '40px' }}>
                    <FontAwesomeIcon
                        style={{ cursor: 'hand' }}
                        icon={faTrash}
                        className='menuIcon'
                        title='Remove Selected'
                        onClick={() => removeSelected()}
                    />
                </div>
            </div>
            <div className='row'>
                <Collapse in={true}>
                    <div style={{ padding: '0px' }}>
                        <table className='table savedImagesTable'>
                            <tbody>
                                {imageDataCtx.imagesList.map((data, i) => (
                                    <tr
                                        ref={(e) => (pRefs.current[i] = e)}
                                        key={`keyImages-${data.name}`}
                                    >
                                        <OverlayTrigger
                                            key={`keyImageData-${i}`}
                                            placement='auto'
                                            delay={{
                                                show: 1000,
                                                hide: 0,
                                            }}
                                            trigger={['hover', 'focus']}
                                            rootClose={true}
                                            overlay={
                                                <Popover
                                                    id={`tooltipimages-${data.name}`}
                                                    className='image-info-popup'
                                                    hidden={!showContextPopup}
                                                    title='Image Info'
                                                >
                                                    <Popover.Header as='h3'>
                                                        Image Info
                                                    </Popover.Header>
                                                    <Popover.Body>
                                                        <TooltipContent
                                                            data={data}
                                                        ></TooltipContent>
                                                    </Popover.Body>
                                                </Popover>
                                            }
                                        >
                                            <td
                                                className={
                                                    imageDataCtx.loadedImageFromImageList &&
                                                    imageDataCtx.loadedImageDetails.documentName ===
                                                        data.documentName
                                                        ? 'tableSelected'
                                                        : 'tableNotSelected'
                                                }
                                                id={`image_selection_row_${i}`}
                                            >
                                                <section>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Form.Check
                                                                        inline
                                                                        label=''
                                                                        style={{
                                                                            paddingLeft: '27px',
                                                                        }}
                                                                        type='checkbox'
                                                                        onChange={(e) => {
                                                                            handleCheckedChange(
                                                                                e,
                                                                                data
                                                                            );
                                                                        }}
                                                                        checked={
                                                                            data.isChecked ?? false
                                                                        }
                                                                    />
                                                                </td>

                                                                <td
                                                                    onClick={(e) => {
                                                                        imageDataCtx.setLoadedImage(
                                                                            data.name,
                                                                            true
                                                                        );
                                                                    }}
                                                                >
                                                                    <div className='section-table'>
                                                                        <Description
                                                                            document={data}
                                                                        ></Description>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </section>

                                                {/* </ContextMenuTrigger> */}
                                            </td>
                                        </OverlayTrigger>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Collapse>
            </div>
        </>
    );
};

export default ImagesList;
